const VALID_DEPLOY_TARGETS = new Set(["production", "staging"]);
const DEPLOY_SITE_URLS = Object.freeze({
  production: "https://porsche-ezentrum.us",
  staging: "https://pcnaevents-stg.web.app",
});

export const resolveDeployTarget = (value, fallback = "staging") => {
  const target = String(value || fallback)
    .trim()
    .toLowerCase();

  if (!VALID_DEPLOY_TARGETS.has(target)) {
    throw new Error(
      `REACT_APP_DEPLOY_TARGET must be "production" or "staging"; received "${target}".`,
    );
  }

  return target;
};

export const getDeploySiteUrl = (target) =>
  DEPLOY_SITE_URLS[resolveDeployTarget(target)];
